module.exports = __webpack_public_path__ + "img/CACAO-LOGOTYPE-blanco.00a7df47.svg";